import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import { GoogleMap } from "@react-google-maps/api";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { BasicMapTitle } from "../../../../Utils/Constants";
import { containerStyle, defaultCenter } from "../../../../Data/MiscellaneousData/MapsData";

export default function BasicMap() {

  //   const { isLoaded } = useJsApiLoader({
  //     id: "google-map-script",
  //     googleMapsApiKey: "https://maps.googleapis.com/maps/api/js?key=your_api_key",
  //   });
  
  return (
    <Col xl={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={BasicMapTitle} />
        <CardBody>
          <div className="map-js-height">
            <div id="gmap-simple" className="map-block">
              <GoogleMap mapContainerStyle={containerStyle} center={defaultCenter} zoom={10} />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
